import { combineReducers } from 'redux';

import { routerReducer } from 'react-router-redux';
import { firebaseStateReducer } from 'react-redux-firebase';

import versionReducer from './reducers/version';

export const makeRootReducer = () => {
  return combineReducers({
    router: routerReducer,
    firebase: firebaseStateReducer,
    version: versionReducer
  });
}


// WEBPACK FOOTER //
// ./src/reducers.js